/* eslint-disable import/prefer-default-export */
export const response = (success, message, data) => ({
  success,
  data,
  message: !success && !message ? 'UnexpectedError' : message,
});
